export const setPath = (obj, path, value, i = 0) => {
	if (i >= path.length) return value;

	const key = path[i];
	return { ...obj, [key]: setPath(obj?.[key], path, value, i + 1) };
};
